import React from 'react';

import EventDetailsContent from './content';
import EventDetailsProvider from 'contexts/event-details.context/provider';

const EventDetailsLayout = () => {
  return (
    <EventDetailsProvider>
      <EventDetailsContent />
    </EventDetailsProvider>
  );
};

export default EventDetailsLayout;
